export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-steam-2e85a425e44accf659ed737e799b2882.svg";